var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGnai(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.27891 3.32316L12.0348 0.57735L16.7907 3.32316V8.81477L12.0348 11.5606L7.27891 8.81477V3.32316Z",
    stroke: "#9F9F9F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5201 6.35764L17.276 3.61184L22.0319 6.35764V11.8493L17.276 14.5951L12.5201 11.8493V6.35764Z",
    stroke: "#9F9F9F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5201 12.1507L17.276 9.40494L22.0319 12.1507V17.6424L17.276 20.3882L12.5201 17.6424V12.1507Z",
    stroke: "#9F9F9F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.27891 15.1852L12.0348 12.4394L16.7907 15.1852V20.6768L12.0348 23.4227L7.27891 20.6768V15.1852Z",
    stroke: "#9F9F9F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.96836 12.1507L6.72424 9.40494L11.4801 12.1507V17.6424L6.72424 20.3882L1.96836 17.6424V12.1507Z",
    stroke: "#9F9F9F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1.96836 6.35764L6.72424 3.61184L11.4801 6.35764V11.8493L6.72424 14.5951L1.96836 11.8493V6.35764Z",
    stroke: "#9F9F9F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.125 11.3066C9.91085 11.478 9.81055 11.7202 9.81055 11.9749V12.033C9.81055 12.2865 9.90998 12.5268 10.1204 12.6985L10.1204 12.6985L10.1221 12.6999C10.3064 12.8488 10.5244 12.9138 10.7463 12.9138C10.8112 12.9138 10.8767 12.9078 10.9413 12.8948H10.8565H10.7808L10.7463 12.8349L10.7054 12.764C10.5428 12.755 10.3763 12.6982 10.2372 12.5723L10.234 12.5694L10.234 12.5694C10.2328 12.5683 10.2315 12.5672 10.2303 12.566C10.23 12.5657 10.2296 12.5654 10.2293 12.5651C10.0701 12.4159 10.0034 12.2212 10.0023 12.033C10.0023 12.0315 10.0023 12.03 10.0023 12.0285V11.9805C10.0023 11.9786 10.0023 11.9767 10.0023 11.9749C10.0036 11.7903 10.067 11.5918 10.2316 11.4396L10.125 11.3066ZM10.125 11.3066C10.3114 11.1572 10.5313 11.094 10.7531 11.094C10.8206 11.094 10.889 11.0999 10.957 11.113H11.3565H11.5089V11.3755M10.125 11.3066L11.5089 11.3755M12.9427 11.1063V11.0862H13.4427H13.6209H14.1209V11.3062H13.6209V11.2191H13.4427V11.3062H13.3511L13.2562 11.1063H12.9427ZM12.9427 11.1063H12.9401H12.6961H12.3805L12.3773 11.113M12.9427 11.1063V11.2415H12.9401H12.8164H12.8141H12.6961H12.6905V11.113H12.3773M12.3773 11.113H12.1905H12.0089H11.7533L11.9017 11.2735L12.0089 11.3895L12.1651 11.5584L12.1905 11.5051L12.2447 11.3913L12.3773 11.113ZM11.5089 11.3755H11.4466M12.6905 12.8948V12.7653H12.7248L12.7826 12.8948H12.6905ZM12.8468 12.8948L12.9047 12.7653H12.9427V12.8948H12.8468ZM14.1055 12.8948L13.8681 12.3948H13.9427V12.2191H14.1209V12.3948V12.8948H14.1055Z",
    fill: "white",
    stroke: "#9F9F9F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGnai);
export default __webpack_public_path__ + "static/media/gnai.178221838e3e9d47370fac3ca0a533a1.svg";
export { ForwardRef as ReactComponent };